// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.RentabilidadeAnual_btn-csv-rent_2a3bV {\r\n    border: 1px solid var(--principal-azul);\r\n    justify-content: center;\r\n    padding: 0.5rem 1.5rem;\r\n    border-radius: 25px;\r\n    font-weight: bold;\r\n    cursor: pointer;\r\n    color: var(--principal-azul);\r\n    margin-left: 30px;\r\n    width: 100px;\r\n    display: inline;\n}\r\n", ""]);
// Exports
exports.locals = {
	"btn-csv-rent": "RentabilidadeAnual_btn-csv-rent_2a3bV"
};
module.exports = exports;
